import { render, staticRenderFns } from "./pledgeHome.vue?vue&type=template&id=67455a38&"
import script from "./pledgeHome.vue?vue&type=script&lang=js&"
export * from "./pledgeHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports